import styled, { keyframes, css } from "styled-components";

const blinker = keyframes`
  50% {
    opacity: 0;
  }
`;

export const blinkAnimation = css`
  animation: ${blinker} 0.5s linear 1;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 150px;
  cursor: pointer;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.dataViz.primaryMetricTitleColor};
`;

export const Body = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 3px;
`;

export const Value = styled.div`
  ${({ showBlink }) => showBlink && blinkAnimation}
  font-weight: bold;
  font-size: 26px;
  color: ${({ theme, isEmptyValue }) =>
    isEmptyValue
      ? theme.colors.dataViz.primaryMetricEmptyValueColor
      : theme.colors.dataViz.primaryMetricValueColor};
`;

export const Unit = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.dataViz.primaryMetricUnitColor};
`;

export const Children = styled.div`
  display: flex;
  justify-content: center;
`;
